module.exports = __webpack_public_path__ + "img/pc-button-text-right-04.0dd9112a.svg";